"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StackbarChart = void 0;
var drawPlane_1 = require("../parse/drawPlane");
var getPlanes_1 = require("../parse/getPlanes");
var getIndexNearest_1 = require("../../common/getIndexNearest");
var StackbarChart = function (svg, config) {
    var thickness = config.thickness || 6;
    var innerPaddingStart = config.xAxis.innerPaddingStart || 0;
    var _a = getPlanes_1.getPlanes(config), dataPointGroup = _a.dataPointGroup, yAxisMarks = _a.yAxisMarks, destPlane = _a.destPlane;
    var dataPointGroup2 = dataPointGroup;
    drawPlane_1.drawPlane(svg, config, dataPointGroup2[0], yAxisMarks, destPlane);
    if (config.selectedIndex > -1) {
        var selectLine = destPlane[1];
        var newX = Math.floor(dataPointGroup2[0][config.selectedIndex][0] + thickness / 2) + innerPaddingStart;
        selectLine[0][0] = newX;
        selectLine[1][0] = newX;
        svg.line(selectLine).stroke({ color: config.selectedLineColor, width: 1 });
    }
    Array.from(new Array(dataPointGroup2[0].length)).map(function (_, i) {
        for (var j = 0; j < dataPointGroup2.length; j++) {
            var height = destPlane[0][0][1] - dataPointGroup2[j][i][1];
            dataPointGroup2[j][i][1] = j === 0 ? dataPointGroup2[j][i][1] : dataPointGroup2[j - 1][i][1] - height;
            svg.rect(thickness, height).move(innerPaddingStart + dataPointGroup2[j][i][0], dataPointGroup2[j][i][1]).fill(config.values[j].color);
        }
    });
    var getXY = function (x, y) {
        var nearest = getIndexNearest_1.getIndexNearest(dataPointGroup2, thickness, x, y, getIndexNearest_1.NearestMode.OVER);
        return nearest;
    };
    var getPopupInfo = function (i) {
        var color = '';
        var title = '';
        var value = '';
        return {
            title: config.xAxis.series[i],
            rows: config.values.map(function (it) { return ({ color: it.color, title: it.label, value: it.series[i] }); })
        };
    };
    var getDataPointGroup = function () { return dataPointGroup; };
    return { svg: svg, getXY: getXY, getPopupInfo: getPopupInfo, getDataPointGroup: getDataPointGroup };
};
exports.StackbarChart = StackbarChart;
